module.exports = __webpack_public_path__ + "img/item-bg.f2e63d2b.webp";